<div class="modal-top-bar">
    <h3>Caution!</h3>
</div>
<div class="modal-content mb-4">
    <div [innerHTML]="message"></div>
</div>
<div class="modal-bottom-bar max">
    <button class="button outline mini wide" (click)="dialogRef.close(false)">Cancel</button>
    <button class="button mini wide" (click)="dialogRef.close(true)">Confirm</button>
</div>